<template>
    <b-col lg="12"
           cols="12"
           order-lg="2"
           order="0">
        <b-col lg="6" style="padding: 0;">
            <div class="commissions-total-label">
                <p>Missing amount of turnover<br class="desktop-only"> to maintain the level:</p>
            </div>
            <div class="commissions-total-value">
                <p>{{ amount }}$</p>
            </div>
        </b-col>
    </b-col>
</template>

<script>
    export default {
        computed: {
            amount () {
                return this.$store.getters.qualifications.amount
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/business-qualifications/BusinessQualificationsTurnoverTooSmall.vue